<template>
    <v-dialog name="editRow" v-model="level.dialogValues.dialogShow" data-app="true" persistent max-width="680">
      <v-card>

        <CardUpdatableHeader :row="row" :level="level"/>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="row.dtr_code" :disabled="level.dialogValues.form_disabled" outlined :label="$t('texts._required_code')" :rules="level.dialogOptions.codeRules" required :hint="$t('hints._code')" persistent-hint>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="row.dtr_location" :disabled="level.dialogValues.form_disabled" :label="$t('texts.dtr_location')" :hint="$t('hints.dtr_location')"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="row.dtr_desc"
                  :disabled="level.dialogValues.form_disabled" 
                  :label="$t('texts._desc')"
                  :hint="$t('hints._desc')"
                ></v-text-field>
              </v-col>
            </v-row>
              <v-col v-if="!level.dialogValues.form_create" cols="12">
                <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row.dtr_create,'long') }}<br/>
                <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row.dtr_update,'long') }}
              </v-col>
            <v-row>
            </v-row>
         </v-container>
          <small>*{{ $t('texts.requiredfield') }}</small>
        </v-card-text>

        <CardUpdatableFooter :row="row" :level="level"/>

      </v-card>
    </v-dialog>

</template>

<script>
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';

export default {
    name: 'CardUpdatableDatacenterrow',
    extends: CardUpdatable,
    components: {
        ddoAlert,
        CardUpdatableHeader,
        CardUpdatableFooter
    },
    props: {
    },
    data: function () {
        return {
        }
    }
}
</script>